<template>
<div class="page page_adress">
    <div class="list">
        <div class="item" v-for="(item,index) in dataList" :key="index">
            <div class="item_top" @click="selectinvoice(item)">
                <div class="user">
                    <span class="name">{{ item.company }} </span>
                    <!-- <h2 class="phone"> {{ item.shuihao }}</h2> -->
                </div>
                <div class="user">
                    <span class="phone">税号：{{ item.shuihao }}</span>
                    <!-- <span class="adressDefault" v-if="canSelect==1&&item.default==1">默认</span> -->
                </div>
            </div>
            <div class="item_bottom" style="flex-direction:row-reverse;">
                <!-- <div v-if="canSelect!=1" :class="item.default ? 'default':'default_un'" @click="setDefaultinvoice(item)"><span class="txt">默认发票</span></div> --> 
                <div class="actions clearfix" >
                    <div class="action f-l" @click="editinvoice(item)">编辑</div>
                    <div v-if="canSelect!=1" class="action f-l" @click="deleteinvoice(item)">删除</div>
                </div>
                <div v-if="canSelect==1" :class="item.isSelect ? 'default':'default_un'" @click="selectinvoice(item)"></div>
            </div>
        </div>
    </div>
    <!-- 新建发票 -->
    <div class="bottom">
        <div class="action_add" @click="addInvoice">+新建发票</div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN,
    SELECTINVOICE
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "my-index",
    data() {
        return {
            canSelect: this.$route.query.canSelect,
            invoiceId: this.$route.query.invoiceId,
            publicPath: process.env.BASE_URL,
            pages: {
                page: 1,
                size: 10
            },
            dataList: [],
            token: null
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '我的发票'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log('sdjy://member/memberInfo')
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                this.getData()
                responseCallback({})
            })
        } else {
            this.token = this.$store.getters.token
        }
        // 获取列表
        this.getData();
    },
    mounted() {
        
    },
    methods: {
        // 获取列表
        getData() {
            if (this.token == null) {
                return
            }
            var params = {
                token: this.token,
                page: 1,
                size: 30
            }
            console.log(params)
            this.$api.invoice.invoiceList(params).then(res => {
                if (res.code == 200) {
                    var list = res.result
                    if (this.canSelect == 1) {
                        for (let i = 0; i < list.length; i++) {
                            var invoice = list[i];
                            if (invoice.invoice_id == this.invoiceId) {
                                invoice.isSelect = true
                            } else {
                                invoice.isSelect = false
                            }
                            list[i] = invoice
                        }
                    }
                    console.log('list',list)
                    this.dataList = list
                } else {
                    this.$toast(res.message)
                }
            })
        },
        selectinvoice(item) {
            // console.log(item)
            // return
            if (this.canSelect == 1) {
                var data = {
                    'invoice_id': item.invoice_id,
                    'company': item.company,
                    'shuihao': item.shuihao,
                    'address': item.address,
                    'bank': item.bank,
                    'account': item.account,
                    'phone': item.phone
                }
                // if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                //     var params = {
                //         'data': {
                //             'key': 'selectinvoice',
                //             'value': JSON.stringify(data)
                //         }
                //     }
                //     this.$bridge.callhandler('sdjy://public/saveInfo', params, (data) => {
                //         console.log('sdjy://public/saveInfo')
                //         console.log(params)
                //         console.log(data)
                //         //返回上级页面
                //         var params = {
                //             'data': {}
                //         }
                //         this.$bridge.callhandler('sdjy://public/back', params, (data) => {

                //         })
                //     })

                // } else {
                    this.$store.commit(SELECTINVOICE, {
                        select_invoice: JSON.stringify(data)
                    });
                    this.$router.back()
                // }
            }
        },
        deleteinvoice(item) {
            var params = {
                token: this.token,
                invoice_id: item.invoice_id,
            }
            this.$api.invoice.deleteInvoice(params).then(res => {
                if (res.code == 200) {
                    this.$toast(res.message)
                    this.getData()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        setDefaultinvoice(item) {
            var params = {
                token: this.token,
                invoice_id: item.invoice_id,
                person: item.person,
                phone: item.phone,
                invoice: item.invoice,
                area_name1: item.area_code1,
                area_name2: item.area_code2,
                area_name3: item.area_code3,
                default: 1,
            }
            console.log(params)
            this.$api.invoice.editinvoice(params).then(res => {
                if (res.code == 200) {
                    this.$toast('设置默认地址成功')
                    this.getData()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        editinvoice(item) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/user/invoiceAdd?id=' + item.invoice_id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/user/invoiceAdd',
                    query: {
                        id: item.invoice_id
                    }
                })
            }
        },
        // 新增发票
        addInvoice() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/user/invoiceAdd'
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    name: 'add-invoice'
                })
            }
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
